import { Action, ActionType } from "../../model/actionTypes";
import { OpenDental } from "../../model/user";
import createReducer from "./createReducer";


const initialState:any = {
	groups: {},
	users: {},
	userList : {},
}

export const openDental = createReducer(initialState, {
	[ActionType.LOAD_USER_GROUPS_SUCCESS](state: OpenDental, action: Action<any>) {
		return Object.assign({...state}, action.payload);
	},
	[ActionType.LOAD_USER_LIST_SUCCESS](state: OpenDental, action: Action<any>) {
		return Object.assign({...state}, action.payload);
	},
	[ActionType.LOAD_GROUP_ATTACHES_SUCCESS](state: OpenDental, action: Action<any>) {
		return Object.assign({...state}, action.payload);
	},

});
